<template>
  <div class="flex justify-center items-center" :class="classesWrapper">
    <div class="animate-spin rounded-full border-b-2" :class="classes"></div>
    <span v-if="!hideText" class="ml-3 text-sm text-neutral-600">{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = withDefaults(defineProps<{
  text?: string
  onPrimary?: boolean
  hideText?: boolean
}>(), {
  text: undefined
});

const classes = computed<string[]>(() => {
  const tmp: string[] = [];

  if (props.onPrimary) tmp.push('h-4 w-4 border-white')
  else tmp.push('h-8 w-8 border-primary-600')

  return tmp;
});
const classesWrapper = computed<string[]>(() => {
  const tmp: string[] = [];

  if (!props.hideText) tmp.push('p-4')

  return tmp;
});

const text = computed(() => props.text || t('common.loading'))
</script> 